// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MedicationPopup-module__font-s-10___ICJUa {
  font-size: 10px !important;
}

.MedicationPopup-module__font-s-12___SyH0N {
  font-size: 12px !important;
}

.MedicationPopup-module__font-s-13___dZVZy {
  font-size: 13px !important;
}

.MedicationPopup-module__font-s-14___eCHdH {
  font-size: 14px !important;
}

.MedicationPopup-module__font-s-15___IAHlI {
  font-size: 15px !important;
}

.MedicationPopup-module__font-s-16___zTEgz {
  font-size: 16px !important;
}

.MedicationPopup-module__font-s-18____4P8W {
  font-size: 18px !important;
}

.MedicationPopup-module__font-s-20___RCQkV {
  font-size: 20px !important;
}

.MedicationPopup-module__font-s-22___xRFqu {
  font-size: 22px !important;
}

.MedicationPopup-module__font-s-28___zNBob {
  font-size: 28px !important;
}

.MedicationPopup-module__font-w-400___nZJCt {
  font-weight: 400 !important;
}

.MedicationPopup-module__font-w-500___hrOtB {
  font-weight: 500 !important;
}

.MedicationPopup-module__font-w-600___xq9LT {
  font-weight: 600 !important;
}

.MedicationPopup-module__font-w-700___Gclrv {
  font-weight: 700 !important;
}

.MedicationPopup-module__p-5___14367 {
  padding: 5px !important;
}

.MedicationPopup-module__p-12___zDcXM {
  padding: 12px !important;
}

.MedicationPopup-module__p-16___eTNls {
  padding: 16px !important;
}

.MedicationPopup-module__p-30___a1rCv {
  padding: 30px !important;
}

.MedicationPopup-module__p-b-0___WPCJ3 {
  padding-bottom: 0 !important;
}

.MedicationPopup-module__p-b-5___VK9X8 {
  padding-bottom: 5px !important;
}

.MedicationPopup-module__p-b-10___wnbvD {
  padding-bottom: 10px !important;
}

.MedicationPopup-module__p-b-12___I7RMw {
  padding-bottom: 12px !important;
}

.MedicationPopup-module__p-b-16___jusOm {
  padding-bottom: 16px !important;
}

.MedicationPopup-module__p-b-18___MoJqf {
  padding-bottom: 18px !important;
}

.MedicationPopup-module__p-b-20___S99gb {
  padding-bottom: 20px !important;
}

.MedicationPopup-module__p-b-25___eO73c {
  padding-bottom: 25px !important;
}

.MedicationPopup-module__p-b-30___tRTay {
  padding-bottom: 30px !important;
}

.MedicationPopup-module__p-b-50___u3tei {
  padding-bottom: 50px !important;
}

.MedicationPopup-module__p-t-0___quVSK {
  padding-top: 0 !important;
}

.MedicationPopup-module__p-t-12___vtSPh {
  padding-top: 12px !important;
}

.MedicationPopup-module__p-t-16___tFcKp {
  padding-top: 16px !important;
}

.MedicationPopup-module__p-t-18____w7mj {
  padding-top: 18px !important;
}

.MedicationPopup-module__p-t-20___Pg_Is {
  padding-top: 20px !important;
}

.MedicationPopup-module__p-t-30___yUyG2 {
  padding-top: 30px !important;
}

.MedicationPopup-module__p-t-40___zreqv {
  padding-top: 40px !important;
}

.MedicationPopup-module__p-t-50___e_PNZ {
  padding-top: 50px !important;
}

.MedicationPopup-module__p-l-20___gNXam {
  padding-left: 20px !important;
}

.MedicationPopup-module__p-l-30___C2pRO {
  padding-left: 30px !important;
}

.MedicationPopup-module__p-l-40___gKJnw {
  padding-left: 40px !important;
}

.MedicationPopup-module__p-r-16___TDHwA {
  padding-right: 16px !important;
}

.MedicationPopup-module__p-r-20___Sj3lI {
  padding-right: 20px !important;
}

.MedicationPopup-module__p-r-30___h35bH {
  padding-right: 30px !important;
}

.MedicationPopup-module__p-r-50___SPs2v {
  padding-right: 50px !important;
}

.MedicationPopup-module__p-r-60___HE_Kb {
  padding-right: 60px !important;
}

.MedicationPopup-module__m-b-1___EpdBa {
  margin-bottom: 1px !important;
}

.MedicationPopup-module__m-b-2____FWjd {
  margin-bottom: 2px !important;
}

.MedicationPopup-module__m-b-6___l7fXf {
  margin-bottom: 6px !important;
}

.MedicationPopup-module__m-b-8___UKwhl {
  margin-bottom: 8px !important;
}

.MedicationPopup-module__m-b-10___YC6bY {
  margin-bottom: 10px !important;
}

.MedicationPopup-module__m-b-14___HkHHd {
  margin-bottom: 14px !important;
}

.MedicationPopup-module__m-b-16___Mz2ks {
  margin-bottom: 16px !important;
}

.MedicationPopup-module__m-b-20___zgioH {
  margin-bottom: 20px !important;
}

.MedicationPopup-module__m-b-22___g1fcn {
  margin-bottom: 22px !important;
}

.MedicationPopup-module__m-b-24___pw2JO {
  margin-bottom: 24px !important;
}

.MedicationPopup-module__m-b-30___mP3gQ {
  margin-bottom: 30px !important;
}

.MedicationPopup-module__m-b-32___UMtih {
  margin-bottom: 32px !important;
}

.MedicationPopup-module__m-b-40___EVHgN {
  margin-bottom: 40px !important;
}

.MedicationPopup-module__m-t-2___I9S1m {
  margin-top: 2px !important;
}

.MedicationPopup-module__m-t-3___eSc4D {
  margin-top: 3px !important;
}

.MedicationPopup-module__m-t-4____2is2 {
  margin-top: 4px !important;
}

.MedicationPopup-module__m-t-5___xPEII {
  margin-top: 5px !important;
}

.MedicationPopup-module__m-t-8___cPwJg {
  margin-top: 8px !important;
}

.MedicationPopup-module__m-t-10___dy2cj {
  margin-top: 10px !important;
}

.MedicationPopup-module__m-t-15___XJ5aT {
  margin-top: 15px !important;
}

.MedicationPopup-module__m-t-16___gh1Z7 {
  margin-top: 16px !important;
}

.MedicationPopup-module__m-t-20___z0pZr {
  margin-top: 20px !important;
}

.MedicationPopup-module__m-t-22___t61U_ {
  margin-top: 22px !important;
}

.MedicationPopup-module__m-t-30___s4pen {
  margin-top: 30px !important;
}

.MedicationPopup-module__m-t-32___Cd9GI {
  margin-top: 32px !important;
}

.MedicationPopup-module__m-l-auto___tEZfj {
  margin-left: auto !important;
}

.MedicationPopup-module__m-l-4___ySuVg {
  margin-left: 4px !important;
}

.MedicationPopup-module__m-l-5___WWdZ_ {
  margin-left: 5px !important;
}

.MedicationPopup-module__m-l-6___B4DKP {
  margin-left: 6px !important;
}

.MedicationPopup-module__m-l-8___eo46X {
  margin-left: 8px !important;
}

.MedicationPopup-module__m-l-10___NYvI_ {
  margin-left: 10px !important;
}

.MedicationPopup-module__m-l-16___T9wBP {
  margin-left: 16px !important;
}

.MedicationPopup-module__m-l-20___idUyZ {
  margin-left: 20px !important;
}

.MedicationPopup-module__m-l-24___X1fTk {
  margin-left: 24px !important;
}

.MedicationPopup-module__m-l-30___WlQFO {
  margin-left: 30px !important;
}

.MedicationPopup-module__m-l-35___dI6AO {
  margin-left: 35px !important;
}

.MedicationPopup-module__m-l-40___UXH4y {
  margin-left: 40px !important;
}

.MedicationPopup-module__m-r-8___STg4d {
  margin-right: 8px !important;
}

.MedicationPopup-module__m-r-10___qZW1j {
  margin-right: 10px !important;
}

.MedicationPopup-module__m-r-16___DRdu_ {
  margin-right: 16px !important;
}

.MedicationPopup-module__m-r-20___QUhif {
  margin-right: 20px !important;
}

.MedicationPopup-module__m-r-24___qmshj {
  margin-right: 24px !important;
}

.MedicationPopup-module__m-r-30___zPBXj {
  margin-right: 30px !important;
}

.MedicationPopup-module__m-r-40___J3CLG {
  margin-right: 40px !important;
}

.MedicationPopup-module__border-r-3___q4JWa {
  border-radius: 3px !important;
}

.MedicationPopup-module__border-r-4___jFUCl {
  border-radius: 4px !important;
}

.MedicationPopup-module__border-r-6___gJAqo {
  border-radius: 6px !important;
}

.MedicationPopup-module__border-r-10___nEQsa {
  border-radius: 10px !important;
}

.MedicationPopup-module__border-r-12___HzF4m {
  border-radius: 12px !important;
}

.MedicationPopup-module__border-r-16___AJ3Mn {
  border-radius: 16px !important;
}

.MedicationPopup-module__border-r-50___bNkyo {
  border-radius: 50% !important;
}

.MedicationPopup-module__primary-border___MUOWF {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.MedicationPopup-module__primary-border-b___Cy_9p {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.MedicationPopup-module__primary-border-t___SBCij {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.MedicationPopup-module__primary-border-l___z9fhT {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.MedicationPopup-module__primary-border-r___IKKGA {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.MedicationPopup-module__secondary-border___pBzp4 {
  border: 1px solid #637768;
}

.MedicationPopup-module__secondary-border-b___rSYxS {
  border-bottom: 1px solid #637768;
}

.MedicationPopup-module__secondary-border-t___OhzV1 {
  border-top: 1px solid #637768;
}

.MedicationPopup-module__secondary-border-l____v8en {
  border-left: 1px solid #637768;
}

.MedicationPopup-module__secondary-border-r___zwGhQ {
  border-right: 1px solid #637768;
}

.MedicationPopup-module__gap-0___FpLF2 {
  gap: 0 !important;
}

.MedicationPopup-module__gap-2___v8jzh {
  gap: 2px !important;
}

.MedicationPopup-module__gap-4___xeX9f {
  gap: 4px !important;
}

.MedicationPopup-module__gap-5___toJet {
  gap: 5px !important;
}

.MedicationPopup-module__gap-6___gwQIL {
  gap: 6px !important;
}

.MedicationPopup-module__gap-8___phKUK {
  gap: 8px !important;
}

.MedicationPopup-module__gap-10___CedJv {
  gap: 10px !important;
}

.MedicationPopup-module__gap-12___pjWiU {
  gap: 12px !important;
}

.MedicationPopup-module__gap-14___ocNCI {
  gap: 14px !important;
}

.MedicationPopup-module__gap-16___w0vdt {
  gap: 16px !important;
}

.MedicationPopup-module__gap-18___fTxtu {
  gap: 18px !important;
}

.MedicationPopup-module__gap-20___S4RyI {
  gap: 20px !important;
}

.MedicationPopup-module__gap-24___f2pOi {
  gap: 24px !important;
}

.MedicationPopup-module__gap-26___F4IVX {
  gap: 26px !important;
}

.MedicationPopup-module__gap-30___Vbxkn {
  gap: 30px !important;
}

.MedicationPopup-module__gap-32___J4ie1 {
  gap: 32px !important;
}

.MedicationPopup-module__gap-40___TSiuq {
  gap: 40px !important;
}

.MedicationPopup-module__gap-50___LzcEP {
  gap: 50px !important;
}

.MedicationPopup-module__flex-1___NuLOj {
  flex: 1;
}

.MedicationPopup-module__flex-none___vrChW {
  flex: none !important;
}

.MedicationPopup-module__flex-column___KOPoC {
  display: flex;
  flex-direction: column !important;
}

.MedicationPopup-module__flex-row___ZpNA2 {
  display: flex;
  flex-direction: row !important;
}

.MedicationPopup-module__vertically-centered____vxqZ {
  display: flex;
  align-items: center !important;
}

.MedicationPopup-module__horizontally-centered___TNUL2 {
  display: flex;
  justify-content: center !important;
}

.MedicationPopup-module__horizontally-end___k6qyE {
  display: flex;
  justify-content: end !important;
}

.MedicationPopup-module__vertically-start___ZgtaK {
  display: flex;
  align-items: start !important;
}

.MedicationPopup-module__space-between___EHy0_ {
  display: flex;
  justify-content: space-between !important;
}

.MedicationPopup-module__flex-wrap___rDfLG {
  flex-wrap: wrap !important;
}

.MedicationPopup-module__height-100___U0UqB {
  height: 100%;
}

.MedicationPopup-module__width-50___kHw48 {
  width: 50% !important;
}

.MedicationPopup-module__width-100___V8Wjz {
  width: 100%;
}

.MedicationPopup-module__cursor-pointer___hJ_1K {
  cursor: pointer;
}

.MedicationPopup-module__cursor-not-allowed___paCJJ {
  cursor: not-allowed !important;
}

.MedicationPopup-module__absolute-centered___B8J09 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.MedicationPopup-module__absolute___WSHKa {
  position: absolute;
}

.MedicationPopup-module__relative___T0RtM {
  position: relative;
}

.MedicationPopup-module__fixed___svG58 {
  position: fixed;
}

.MedicationPopup-module__visible___bdQ7M {
  opacity: 1;
}

.MedicationPopup-module__invisible___CRqnK {
  opacity: 0;
}

.MedicationPopup-module__col-90___gaqjF {
  width: 90% !important;
}

.MedicationPopup-module__col-auto___PYhC3 {
  width: auto !important;
}

.MedicationPopup-module__medical-tabs___izsG2 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.MedicationPopup-module__medical-table-new___TFGEk {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MedicationPopup-module__medical-table-new___TFGEk:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MedicationPopup-module__medical-table-new___TFGEk::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MedicationPopup-module__medical-table-new___TFGEk::-webkit-scrollbar-track {
  display: none;
}
.MedicationPopup-module__medical-table-new___TFGEk.MedicationPopup-module__no-pagination___sKOly {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MedicationPopup-module__medical-table-new___TFGEk.MedicationPopup-module__no-pagination___sKOly:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MedicationPopup-module__medical-table-new___TFGEk.MedicationPopup-module__no-pagination___sKOly::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MedicationPopup-module__medical-table-new___TFGEk.MedicationPopup-module__no-pagination___sKOly::-webkit-scrollbar-track {
  display: none;
}

.MedicationPopup-module__medical-table-empty___RTWsY {
  padding: 14px 40px !important;
}

.MedicationPopup-module__icon-btn___DQYlU {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.MedicationPopup-module__search-icon___uKQrO {
  width: 24px;
  height: 24px;
  align-self: center;
}

.MedicationPopup-module__disable-select___fUX7G {
  user-select: none;
}

.MedicationPopup-module__break-word___Q7uqZ {
  word-break: break-word;
}

.MedicationPopup-module__popup-clear-btn___HcwvX {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.MedicationPopup-module__scroll-m-b-20___tdyIp {
  scroll-margin-bottom: 20px;
}

.MedicationPopup-module__searchContainer___roZsO {
  padding: 25px 30px 0 30px;
}
.MedicationPopup-module__searchContainer___roZsO .MedicationPopup-module__autocomplete___Hgmyx {
  width: 50%;
}
.MedicationPopup-module__searchContainer___roZsO .MedicationPopup-module__option___sS2bZ {
  color: #375844;
}

.MedicationPopup-module__grid___yjSgZ {
  display: grid;
  padding: 25px 30px;
  grid-row-gap: 25px;
  grid-column-gap: 25px;
  grid-template-columns: repeat(3, 1fr);
}
.MedicationPopup-module__grid___yjSgZ .MedicationPopup-module__width75___ENpoi {
  grid-column: 2 span;
}
.MedicationPopup-module__grid___yjSgZ .MedicationPopup-module__width100___Iy0wP {
  grid-column: 3 span;
}
.MedicationPopup-module__grid___yjSgZ .MedicationPopup-module__gap6___HoYeR {
  gap: 6px;
}

.MedicationPopup-module__buttonsContainer___cNyiT {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
  justify-content: end;
  padding: 30px;
  display: flex;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/MedicationPopup/MedicationPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,yBAAA;AA8pBF;AA5pBE;EACE,UAAA;AA8pBJ;AA3pBE;EACE,cAAA;AA6pBJ;;AAzpBA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qCAAA;AA4pBF;AA1pBE;EACE,mBAAA;AA4pBJ;AAzpBE;EACE,mBAAA;AA2pBJ;AAxpBE;EACE,QAAA;AA0pBJ;;AAtpBA;EACE,2CAAA;EACA,oBAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;AAypBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.searchContainer {\n  padding: 25px 30px 0 30px;\n\n  .autocomplete {\n    width: 50%;\n  }\n\n  .option {\n    color: get-color(greenNew, dark);\n  }\n}\n\n.grid {\n  display: grid;\n  padding: 25px 30px;\n  grid-row-gap: 25px;\n  grid-column-gap: 25px;\n  grid-template-columns: repeat(3, 1fr);\n\n  .width75 {\n    grid-column: 2 span;\n  }\n\n  .width100 {\n    grid-column: 3 span;\n  }\n\n  .gap6 {\n    gap: 6px;\n  }\n}\n\n.buttonsContainer {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n  justify-content: end;\n  padding: 30px;\n  display: flex;\n  gap: 16px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `MedicationPopup-module__font-s-10___ICJUa`,
	"fontS12": `MedicationPopup-module__font-s-12___SyH0N`,
	"fontS13": `MedicationPopup-module__font-s-13___dZVZy`,
	"fontS14": `MedicationPopup-module__font-s-14___eCHdH`,
	"fontS15": `MedicationPopup-module__font-s-15___IAHlI`,
	"fontS16": `MedicationPopup-module__font-s-16___zTEgz`,
	"fontS18": `MedicationPopup-module__font-s-18____4P8W`,
	"fontS20": `MedicationPopup-module__font-s-20___RCQkV`,
	"fontS22": `MedicationPopup-module__font-s-22___xRFqu`,
	"fontS28": `MedicationPopup-module__font-s-28___zNBob`,
	"fontW400": `MedicationPopup-module__font-w-400___nZJCt`,
	"fontW500": `MedicationPopup-module__font-w-500___hrOtB`,
	"fontW600": `MedicationPopup-module__font-w-600___xq9LT`,
	"fontW700": `MedicationPopup-module__font-w-700___Gclrv`,
	"p5": `MedicationPopup-module__p-5___14367`,
	"p12": `MedicationPopup-module__p-12___zDcXM`,
	"p16": `MedicationPopup-module__p-16___eTNls`,
	"p30": `MedicationPopup-module__p-30___a1rCv`,
	"pB0": `MedicationPopup-module__p-b-0___WPCJ3`,
	"pB5": `MedicationPopup-module__p-b-5___VK9X8`,
	"pB10": `MedicationPopup-module__p-b-10___wnbvD`,
	"pB12": `MedicationPopup-module__p-b-12___I7RMw`,
	"pB16": `MedicationPopup-module__p-b-16___jusOm`,
	"pB18": `MedicationPopup-module__p-b-18___MoJqf`,
	"pB20": `MedicationPopup-module__p-b-20___S99gb`,
	"pB25": `MedicationPopup-module__p-b-25___eO73c`,
	"pB30": `MedicationPopup-module__p-b-30___tRTay`,
	"pB50": `MedicationPopup-module__p-b-50___u3tei`,
	"pT0": `MedicationPopup-module__p-t-0___quVSK`,
	"pT12": `MedicationPopup-module__p-t-12___vtSPh`,
	"pT16": `MedicationPopup-module__p-t-16___tFcKp`,
	"pT18": `MedicationPopup-module__p-t-18____w7mj`,
	"pT20": `MedicationPopup-module__p-t-20___Pg_Is`,
	"pT30": `MedicationPopup-module__p-t-30___yUyG2`,
	"pT40": `MedicationPopup-module__p-t-40___zreqv`,
	"pT50": `MedicationPopup-module__p-t-50___e_PNZ`,
	"pL20": `MedicationPopup-module__p-l-20___gNXam`,
	"pL30": `MedicationPopup-module__p-l-30___C2pRO`,
	"pL40": `MedicationPopup-module__p-l-40___gKJnw`,
	"pR16": `MedicationPopup-module__p-r-16___TDHwA`,
	"pR20": `MedicationPopup-module__p-r-20___Sj3lI`,
	"pR30": `MedicationPopup-module__p-r-30___h35bH`,
	"pR50": `MedicationPopup-module__p-r-50___SPs2v`,
	"pR60": `MedicationPopup-module__p-r-60___HE_Kb`,
	"mB1": `MedicationPopup-module__m-b-1___EpdBa`,
	"mB2": `MedicationPopup-module__m-b-2____FWjd`,
	"mB6": `MedicationPopup-module__m-b-6___l7fXf`,
	"mB8": `MedicationPopup-module__m-b-8___UKwhl`,
	"mB10": `MedicationPopup-module__m-b-10___YC6bY`,
	"mB14": `MedicationPopup-module__m-b-14___HkHHd`,
	"mB16": `MedicationPopup-module__m-b-16___Mz2ks`,
	"mB20": `MedicationPopup-module__m-b-20___zgioH`,
	"mB22": `MedicationPopup-module__m-b-22___g1fcn`,
	"mB24": `MedicationPopup-module__m-b-24___pw2JO`,
	"mB30": `MedicationPopup-module__m-b-30___mP3gQ`,
	"mB32": `MedicationPopup-module__m-b-32___UMtih`,
	"mB40": `MedicationPopup-module__m-b-40___EVHgN`,
	"mT2": `MedicationPopup-module__m-t-2___I9S1m`,
	"mT3": `MedicationPopup-module__m-t-3___eSc4D`,
	"mT4": `MedicationPopup-module__m-t-4____2is2`,
	"mT5": `MedicationPopup-module__m-t-5___xPEII`,
	"mT8": `MedicationPopup-module__m-t-8___cPwJg`,
	"mT10": `MedicationPopup-module__m-t-10___dy2cj`,
	"mT15": `MedicationPopup-module__m-t-15___XJ5aT`,
	"mT16": `MedicationPopup-module__m-t-16___gh1Z7`,
	"mT20": `MedicationPopup-module__m-t-20___z0pZr`,
	"mT22": `MedicationPopup-module__m-t-22___t61U_`,
	"mT30": `MedicationPopup-module__m-t-30___s4pen`,
	"mT32": `MedicationPopup-module__m-t-32___Cd9GI`,
	"mLAuto": `MedicationPopup-module__m-l-auto___tEZfj`,
	"mL4": `MedicationPopup-module__m-l-4___ySuVg`,
	"mL5": `MedicationPopup-module__m-l-5___WWdZ_`,
	"mL6": `MedicationPopup-module__m-l-6___B4DKP`,
	"mL8": `MedicationPopup-module__m-l-8___eo46X`,
	"mL10": `MedicationPopup-module__m-l-10___NYvI_`,
	"mL16": `MedicationPopup-module__m-l-16___T9wBP`,
	"mL20": `MedicationPopup-module__m-l-20___idUyZ`,
	"mL24": `MedicationPopup-module__m-l-24___X1fTk`,
	"mL30": `MedicationPopup-module__m-l-30___WlQFO`,
	"mL35": `MedicationPopup-module__m-l-35___dI6AO`,
	"mL40": `MedicationPopup-module__m-l-40___UXH4y`,
	"mR8": `MedicationPopup-module__m-r-8___STg4d`,
	"mR10": `MedicationPopup-module__m-r-10___qZW1j`,
	"mR16": `MedicationPopup-module__m-r-16___DRdu_`,
	"mR20": `MedicationPopup-module__m-r-20___QUhif`,
	"mR24": `MedicationPopup-module__m-r-24___qmshj`,
	"mR30": `MedicationPopup-module__m-r-30___zPBXj`,
	"mR40": `MedicationPopup-module__m-r-40___J3CLG`,
	"borderR3": `MedicationPopup-module__border-r-3___q4JWa`,
	"borderR4": `MedicationPopup-module__border-r-4___jFUCl`,
	"borderR6": `MedicationPopup-module__border-r-6___gJAqo`,
	"borderR10": `MedicationPopup-module__border-r-10___nEQsa`,
	"borderR12": `MedicationPopup-module__border-r-12___HzF4m`,
	"borderR16": `MedicationPopup-module__border-r-16___AJ3Mn`,
	"borderR50": `MedicationPopup-module__border-r-50___bNkyo`,
	"primaryBorder": `MedicationPopup-module__primary-border___MUOWF`,
	"primaryBorderB": `MedicationPopup-module__primary-border-b___Cy_9p`,
	"primaryBorderT": `MedicationPopup-module__primary-border-t___SBCij`,
	"primaryBorderL": `MedicationPopup-module__primary-border-l___z9fhT`,
	"primaryBorderR": `MedicationPopup-module__primary-border-r___IKKGA`,
	"secondaryBorder": `MedicationPopup-module__secondary-border___pBzp4`,
	"secondaryBorderB": `MedicationPopup-module__secondary-border-b___rSYxS`,
	"secondaryBorderT": `MedicationPopup-module__secondary-border-t___OhzV1`,
	"secondaryBorderL": `MedicationPopup-module__secondary-border-l____v8en`,
	"secondaryBorderR": `MedicationPopup-module__secondary-border-r___zwGhQ`,
	"gap0": `MedicationPopup-module__gap-0___FpLF2`,
	"gap2": `MedicationPopup-module__gap-2___v8jzh`,
	"gap4": `MedicationPopup-module__gap-4___xeX9f`,
	"gap5": `MedicationPopup-module__gap-5___toJet`,
	"gap6": `MedicationPopup-module__gap-6___gwQIL`,
	"gap8": `MedicationPopup-module__gap-8___phKUK`,
	"gap10": `MedicationPopup-module__gap-10___CedJv`,
	"gap12": `MedicationPopup-module__gap-12___pjWiU`,
	"gap14": `MedicationPopup-module__gap-14___ocNCI`,
	"gap16": `MedicationPopup-module__gap-16___w0vdt`,
	"gap18": `MedicationPopup-module__gap-18___fTxtu`,
	"gap20": `MedicationPopup-module__gap-20___S4RyI`,
	"gap24": `MedicationPopup-module__gap-24___f2pOi`,
	"gap26": `MedicationPopup-module__gap-26___F4IVX`,
	"gap30": `MedicationPopup-module__gap-30___Vbxkn`,
	"gap32": `MedicationPopup-module__gap-32___J4ie1`,
	"gap40": `MedicationPopup-module__gap-40___TSiuq`,
	"gap50": `MedicationPopup-module__gap-50___LzcEP`,
	"flex1": `MedicationPopup-module__flex-1___NuLOj`,
	"flexNone": `MedicationPopup-module__flex-none___vrChW`,
	"flexColumn": `MedicationPopup-module__flex-column___KOPoC`,
	"flexRow": `MedicationPopup-module__flex-row___ZpNA2`,
	"verticallyCentered": `MedicationPopup-module__vertically-centered____vxqZ`,
	"horizontallyCentered": `MedicationPopup-module__horizontally-centered___TNUL2`,
	"horizontallyEnd": `MedicationPopup-module__horizontally-end___k6qyE`,
	"verticallyStart": `MedicationPopup-module__vertically-start___ZgtaK`,
	"spaceBetween": `MedicationPopup-module__space-between___EHy0_`,
	"flexWrap": `MedicationPopup-module__flex-wrap___rDfLG`,
	"height100": `MedicationPopup-module__height-100___U0UqB`,
	"width50": `MedicationPopup-module__width-50___kHw48`,
	"width100": `MedicationPopup-module__width-100___V8Wjz`,
	"cursorPointer": `MedicationPopup-module__cursor-pointer___hJ_1K`,
	"cursorNotAllowed": `MedicationPopup-module__cursor-not-allowed___paCJJ`,
	"absoluteCentered": `MedicationPopup-module__absolute-centered___B8J09`,
	"absolute": `MedicationPopup-module__absolute___WSHKa`,
	"relative": `MedicationPopup-module__relative___T0RtM`,
	"fixed": `MedicationPopup-module__fixed___svG58`,
	"visible": `MedicationPopup-module__visible___bdQ7M`,
	"invisible": `MedicationPopup-module__invisible___CRqnK`,
	"col90": `MedicationPopup-module__col-90___gaqjF`,
	"colAuto": `MedicationPopup-module__col-auto___PYhC3`,
	"medicalTabs": `MedicationPopup-module__medical-tabs___izsG2`,
	"medicalTableNew": `MedicationPopup-module__medical-table-new___TFGEk`,
	"noPagination": `MedicationPopup-module__no-pagination___sKOly`,
	"medicalTableEmpty": `MedicationPopup-module__medical-table-empty___RTWsY`,
	"iconBtn": `MedicationPopup-module__icon-btn___DQYlU`,
	"searchIcon": `MedicationPopup-module__search-icon___uKQrO`,
	"disableSelect": `MedicationPopup-module__disable-select___fUX7G`,
	"breakWord": `MedicationPopup-module__break-word___Q7uqZ`,
	"popupClearBtn": `MedicationPopup-module__popup-clear-btn___HcwvX`,
	"scrollMB20": `MedicationPopup-module__scroll-m-b-20___tdyIp`,
	"searchContainer": `MedicationPopup-module__searchContainer___roZsO`,
	"autocomplete": `MedicationPopup-module__autocomplete___Hgmyx`,
	"option": `MedicationPopup-module__option___sS2bZ`,
	"grid": `MedicationPopup-module__grid___yjSgZ`,
	"width75": `MedicationPopup-module__width75___ENpoi`,
	"width100": `MedicationPopup-module__width100___Iy0wP`,
	"gap6": `MedicationPopup-module__gap6___HoYeR`,
	"buttonsContainer": `MedicationPopup-module__buttonsContainer___cNyiT`
};
module.exports = ___CSS_LOADER_EXPORT___;
